import { useTranslations } from "adapters/i18n";
import { useCallback } from "react";
import type {
  NotifyFn,
  UserManagementFilter,
} from "../../../userManagement.types";
import userService from "../../../userService";
import type { GetUsersFn } from "../userList.types";
import { toUser } from "../userList.utils";

type UseGetUsersProps = {
  clientId: number | null;
  filter: UserManagementFilter | null;
  onNotify: NotifyFn;
};

export function useGetUsers({ clientId, filter, onNotify }: UseGetUsersProps) {
  const { t } = useTranslations();

  const getUsers: GetUsersFn = useCallback(
    async ({ limit, offset }) => {
      try {
        if (!filter || clientId == null) {
          return { total: 0, itens: [] };
        }

        const usersResult = await userService.listUsers(limit, offset, {
          ...filter,
          clientId,
        });

        return {
          total: usersResult.total,
          itens: usersResult.data.map((user) => toUser(user, clientId)),
        };
      } catch (error) {
        onNotify(t("user:search-users-error"), "error");

        return { total: 0, itens: [] };
      }
    },
    [clientId, filter, onNotify, t]
  );

  return { getUsers };
}
